export default {"src":"/_next/static/media/bell.3105bc45.svg","height":21,"width":21};